var map = {
	"./music-instructions.json": 4287,
	"./music-library-intro2024.json": 4288,
	"./music-library-launch2024.json": 4289,
	"./music-progression.json": 4290,
	"./startSourcesAdvanced.json": 4291,
	"./startSourcesSimple.json": 4292,
	"./startSourcesSimple2.json": 4293,
	"./startSourcesTracks.json": 4294
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4029;